import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { CATEGORIES } from "./useLeadDetail";

export default function AddOrderDialog({ open, onOpenChange, orderData, setOrderData, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#FDFBF7] border-[#E7E5E4]">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: "Playfair Display, serif" }}>Add Order</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4 mt-4">
          <div>
            <label className="block text-sm font-medium text-[#1C1917] mb-1">Order Number *</label>
            <input
              type="text"
              value={orderData.order_number}
              onChange={(e) => setOrderData((prev) => ({ ...prev, order_number: e.target.value }))}
              className="form-input"
              required
              data-testid="order-number-input"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#1C1917] mb-1">Amount (₹) *</label>
            <input
              type="number"
              value={orderData.amount}
              onChange={(e) => setOrderData((prev) => ({ ...prev, amount: e.target.value }))}
              className="form-input"
              required
              min="0"
              step="0.01"
              data-testid="order-amount-input"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#1C1917] mb-1">Category *</label>
            <Select value={orderData.category} onValueChange={(v) => setOrderData((prev) => ({ ...prev, category: v }))}>
              <SelectTrigger data-testid="order-category-select">
                <SelectValue placeholder="Select category" />
              </SelectTrigger>
              <SelectContent>
                {CATEGORIES.map((c) => (<SelectItem key={c} value={c}>{c}</SelectItem>))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <label className="block text-sm font-medium text-[#1C1917] mb-1">Notes</label>
            <textarea
              value={orderData.notes}
              onChange={(e) => setOrderData((prev) => ({ ...prev, notes: e.target.value }))}
              className="form-input min-h-[60px]"
              data-testid="order-notes-input"
            />
          </div>
          <div className="flex gap-3 justify-end pt-2">
            <button type="button" onClick={() => onOpenChange(false)} className="btn-secondary">Cancel</button>
            <button
              type="submit"
              className="btn-primary"
              disabled={!orderData.order_number || !orderData.amount || !orderData.category}
              data-testid="submit-order"
            >
              Add Order
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
